module.exports = __webpack_public_path__ + "static/media/200watt.a6dd948f.jpg";